// @flow

import * as React from 'react'
import ShopAdminItemListItem from './item-list-item'
import type {ShopItem} from '../../../types'

type Props = {
  items: $ReadOnlyArray<ShopItem>,
}

class ShopAdminItemList extends React.Component<Props> {
  render() {
    return (
      <ul className="shop-admin-item-list">
        {this.props.items.map(item => (
          <ShopAdminItemListItem key={item.id} item={item} />
        ))}
      </ul>
    )
  }
}

export default ShopAdminItemList
